import { getValidationLogic } from './getValidationLogic'

const profile = (type: 'real_person' | 'legal_person') => {
  if (type === 'real_person') {
    return {
      national_id: {
        presence: {
          allowEmpty: getValidationLogic('user', 'profile', 'national_id', 'allowEmpty'),
          message: '^inputError.requiredField'
        },
        length: {
          is: Number(getValidationLogic('user', 'profile', 'national_id', 'len')),
          message: '^inputError.invalidNationalId'
        }
      },
      first_name: {
        presence: {
          allowEmpty: getValidationLogic('user', 'profile', 'first_name', 'allowEmpty'),
          message: '^inputError.requiredField'
        }
      },
      last_name: {
        presence: {
          allowEmpty: getValidationLogic('user', 'profile', 'last_name', 'allowEmpty'),
          message: '^inputError.requiredField'
        }
      },
      birth_date: {
        presence: {
          allowEmpty: getValidationLogic('user', 'profile', 'birth_date', 'allowEmpty'),
          message: '^inputError.requiredField'
        }
      },
      postal_code: {
        presence: {
          allowEmpty: getValidationLogic('user', 'profile', 'postal_code', 'allowEmpty'),
          message: '^inputError.requiredField'
        },
        length: {
          is: Number(getValidationLogic('user', 'profile', 'postal_code', 'len')),
          message: '^inputError.invalidPostalCode'
        }
      },
      address: {
        presence: {
          allowEmpty: getValidationLogic('user', 'profile', 'address', 'allowEmpty'),
          message: '^inputError.requiredField'
        }
      }
    }
  } else {
    return {
      company_name: {
        presence: {
          allowEmpty: getValidationLogic('user', 'profile', 'company_name', 'allowEmpty'),
          message: '^inputError.requiredField'
        }
      },
      company_national_id: {
        presence: {
          allowEmpty: getValidationLogic('user', 'profile', 'legal_national_code', 'allowEmpty'),
          message: '^inputError.requiredField'
        }
      },
      company_registration_number: {
        presence: {
          allowEmpty: getValidationLogic('user', 'profile', 'company_registration_number', 'allowEmpty'),
          message: '^inputError.requiredField'
        }
      },
      postal_code: {
        presence: {
          allowEmpty: getValidationLogic('user', 'profile', 'postal_code', 'allowEmpty'),
          message: '^inputError.requiredField'
        },
        length: {
          is: Number(getValidationLogic('user', 'profile', 'postal_code', 'len')),
          message: '^inputError.invalidPostalCode'
        }
      },
      address: {
        presence: {
          allowEmpty: getValidationLogic('user', 'profile', 'address', 'allowEmpty'),
          message: '^inputError.requiredField'
        }
      }
    }
  }
}

export default profile
